import { CopilotChannelContext } from 'copilot-toolkit/channel/CopilotChannelContext';
import { useSubscribeToCopilotChannel } from 'copilot-toolkit/channel/hooks/useSubscribeToCopilotChannel';
import emptyFunction from 'react-utils/emptyFunction';
import { useCallback, useContext, useRef, useState } from 'react';
import { MSG_TYPE_MODAL_DIALOG_CLOSE } from 'ui-addon-iframeable/messaging/IFrameMessageTypes';
import { useHostAppName } from './hooks/useHostAppName';
import { buildModalUrl } from './utils/buildModalUrl';

// @ts-expect-error Not Typed
import { IFrame } from 'ui-addon-iframeable/host/IFrame';
import { jsx as _jsx } from "react/jsx-runtime";
const BREEZE_MODAL_RESIZE = 'BREEZE_MODAL_RESIZE';
const DEFAULT_WIDTH = 500;
const DEFAULT_HEIGHT = 600;
const COLLABORATION_SIDEBAR_WIDTH = 465;
const MODAL_OFFSET_MARGIN = 8;
const MODAL_OFFSET_WIDTH = COLLABORATION_SIDEBAR_WIDTH + MODAL_OFFSET_MARGIN;
const BreezeEmailSupportModalHost = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [width, setWidth] = useState(DEFAULT_WIDTH);
  const [height, setHeight] = useState(DEFAULT_HEIGHT);
  const hostAppName = useHostAppName();
  const contextValue = useContext(CopilotChannelContext);
  const instanceId = contextValue === null || contextValue === void 0 ? void 0 : contextValue.instanceId;
  const iframeSrcRef = useRef(undefined);
  if (!iframeSrcRef.current) {
    iframeSrcRef.current = buildModalUrl('/breeze-modal', hostAppName, instanceId);
  }
  const handleMessage = useCallback(message => {
    var _message$payload, _message$payload2;
    if (((_message$payload = message.payload) === null || _message$payload === void 0 ? void 0 : _message$payload.type) === MSG_TYPE_MODAL_DIALOG_CLOSE) {
      setIsVisible(false);
      return;
    }
    if (((_message$payload2 = message.payload) === null || _message$payload2 === void 0 ? void 0 : _message$payload2.type) === BREEZE_MODAL_RESIZE) {
      if (message.payload.width) setWidth(message.payload.width);
      if (message.payload.height) setHeight(message.payload.height);
    }
  }, []);
  const handleOpen = useCallback(() => setIsVisible(true), []);
  useSubscribeToCopilotChannel('OPEN_BREEZE_EMAIL_SUPPORT_MODAL', handleOpen);
  const containerStyle = {
    position: 'fixed',
    bottom: MODAL_OFFSET_MARGIN,
    right: MODAL_OFFSET_WIDTH,
    zIndex: 1112,
    display: isVisible ? 'block' : 'none',
    pointerEvents: 'auto'
  };
  return /*#__PURE__*/_jsx("div", {
    style: containerStyle,
    children: /*#__PURE__*/_jsx(IFrame, {
      appName: "breeze-modal-ui",
      height: isVisible ? height : 0,
      initTimeout: 20000,
      name: "breeze-email-support-modal",
      onMessage: handleMessage,
      onReady: emptyFunction,
      scrolling: false,
      src: iframeSrcRef.current,
      width: isVisible ? width : 0
    })
  });
};
export default BreezeEmailSupportModalHost;